/**
 * Registers aws-codebuild plugin APIs in the frontend system.
 *
 * DEFERRED — cannot migrate to native without upstream changes.
 * Status: BLOCKED (upstream) — app-side compat only.
 *
 * Blocker: `@aws/aws-codebuild-plugin-for-backstage` does not export
 * `awsCodeBuildApiRef` or `AwsCodeBuildApiClient` from its public type surface
 * (index.d.ts). Both are internal to the plugin's legacy `createPlugin` wiring.
 * Without these exports a native `ApiBlueprint` factory cannot be written.
 *
 * `EntityAwsCodeBuildCard` depends on `awsCodeBuildApiRef` (`plugin.aws-codebuild.service`)
 * at runtime; without this module the CI/CD tab throws NotImplementedError.
 *
 * Migration path: Wait for upstream to export the apiRef + client class publicly,
 * then apply the same pattern used for `githubPullRequestsModule`.
 * Upstream: https://github.com/awslabs/backstage-plugins-for-aws
 */
import { convertLegacyPlugin } from '@backstage/core-compat-api';
import { awsCodeBuildPlugin } from '@aws/aws-codebuild-plugin-for-backstage';

export default convertLegacyPlugin(awsCodeBuildPlugin, { extensions: [] });
